export default {

    handleFormValidation() {

        let oForm = $('#form-empresa');

        let aRules = {
            nombre: {
                required: true
            },
            rut: {
                required: true,
                rut: true
            },
        };

        let aMessages = {
            nombre: {
                required: 'El campo Nombre es obligatorio.'
            },
            rut: {
                required: 'El campo RUT es obligatorio.',
                rut: 'El campo RUT tiene un formato inválido.'
            },
        };

        // Validación del formulario
        FormHelper.validate(oForm, aRules, aMessages);
    },

    initTabChange() {
        // Manejar el cambio de pestañas y guardar la pestaña activa
        $('#emailTabs a').on('shown.bs.tab', function (e) {
            let activeTab = $(e.target).attr('href');
            $('#activeTab').val(activeTab);
        });

        // Activar la pestaña guardada al cargar la página
        let activeTab = $('#activeTab').val();
        if (activeTab) {
            $(`#emailTabs a[href="${activeTab}"]`).tab('show');
        }
    },

    initCombos() {
        $('#cmbTipo').select2({
            placeholder: "Seleccionar...",
            allowClear: true
        });
        $('.select2').select2({
            placeholder: "Seleccionar...",
            allowClear: true
        });
    },

    initCheckBoxes() {
        $('#chkActivo').bootstrapSwitch({
            onText: 'SI',
            offText: 'NO'
        });

        $('.js-switch').bootstrapSwitch({
            onText: 'SI',
            offText: 'NO'
        });
    },

    init() {
        this.handleFormValidation();
        this.initCombos();
        this.initCheckBoxes();
        this.initTabChange();
    },

    initIndex() {
        this.initCombos();
        FormHelper.handleSearch();
    },

    /**
     * Elimina un registro a traves de un POST
     *
     * @param {Object} form Formulario que elimina el registro a través de la acción configurada
     * @param {String} nombre Nombre del registro a eliminar
     */
    eliminar(form, nombre) {
        let mensaje = '<p>¿Realmente deseas eliminar la Empresa <strong>' + nombre + '</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>';
        FormHelper.confirm(form, mensaje);
    },

    // Funciones para manejo de bodegas
    agregarBodega() {
        $('#bodegaModalLabel').text('Agregar Bodega');
        $('#formBodega')[0].reset();
        $('#bodega_id').val('');
        $('#bodegaModal').modal('show');
    },

    editarBodega(id) {
        $('#bodegaModalLabel').text('Editar Bodega');

        $.get(`/api/bodegas-entrega/${id}`)
            .done(function (bodega) {
                $('#bodega_id').val(bodega.id);
                $('#bodega_nombre').val(bodega.nombre);
                $('#bodega_direccion').val(bodega.direccion);
                $('#bodega_comuna').val(bodega.comuna);
                $('#bodega_region').val(bodega.region);
                $('#bodega_resolucion').val(bodega.resolucion);
                $('#bodegaModal').modal('show');
            })
            .fail(function () {
                toastr.error('Error al cargar los datos de la bodega');
            });
    },

    guardarBodega() {
        const formData = $('#formBodega').serialize();
        const bodegaId = $('#bodega_id').val();
        const url = bodegaId ? `/api/bodegas-entrega/${bodegaId}` : '/api/bodegas-entrega';
        const method = bodegaId ? 'PUT' : 'POST';

        $.ajax({
            url: url,
            method: method,
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                toastr.success(response.message);
                $('#bodegaModal').modal('hide');

                // Recargar la tabla de bodegas
                setTimeout(() => {
                    location.reload();
                }, 1000);
            },
            error: function (xhr) {
                const errors = xhr.responseJSON?.errors;
                if (errors) {
                    let errorMessages = '';
                    for (let field in errors) {
                        errorMessages += errors[field].join('<br>') + '<br>';
                    }
                    toastr.error(errorMessages);
                } else {
                    toastr.error('Error al guardar la bodega');
                }
            }
        });
    },

    eliminarBodega(id) {
        if (!confirm('¿Está seguro de eliminar esta bodega?')) {
            return;
        }

        $.ajax({
            url: `/api/bodegas-entrega/${id}`,
            method: 'DELETE',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                toastr.success(response.message);

                // Eliminar la fila de la tabla
                $(`tr[data-bodega-id="${id}"]`).fadeOut(400, function () {
                    $(this).remove();
                });

                // Actualizar el mapa si está inicializado
                if (window.mapaBodegas) {
                    Empresas.actualizarMapa();
                }
            },
            error: function () {
                toastr.error('Error al eliminar la bodega');
            }
        });
    },

    // Funciones para el mapa
    inicializarMapa() {
        if (!document.getElementById('mapa-bodegas') || !window.L) {
            return;
        }

        // Inicializar el mapa centrado en Santiago
        window.mapaBodegas = L.map('mapa-bodegas').setView([-33.4489, -70.6693], 8);

        // Agregar capa de mapas
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
        }).addTo(window.mapaBodegas);

        // Cargar y mostrar los puntos
        this.cargarPuntosMapa();
    },

    cargarPuntosMapa() {
        const rut = this.empresaRut;

        $.get('/mapa/puntos', {rut: rut})
            .done((data) => {
                this.mostrarPuntosEnMapa(data);
            })
            .fail(() => {
                console.error('Error al cargar los puntos del mapa');
            });
    },

    mostrarPuntosEnMapa(data) {
        // Limpiar marcadores existentes
        if (window.marcadoresMapa) {
            window.marcadoresMapa.forEach(marker => {
                window.mapaBodegas.removeLayer(marker);
            });
        }
        window.marcadoresMapa = [];

        const bounds = L.latLngBounds();

        // Agregar puntos de referencia
        Object.values(data.puntos_referencia).forEach(punto => {
            let color, icono;

            switch (punto.tipo) {
                case 'aeropuerto':
                    color = 'green';
                    icono = '✈️';
                    break;
                case 'puerto_maritimo':
                    color = 'lightblue';
                    icono = '🚢';
                    break;
                case 'puerto_terrestre':
                    color = 'orange';
                    icono = '🚛';
                    break;
                default:
                    color = 'gray';
                    icono = '📍';
            }

            const marker = L.circleMarker([punto.lat, punto.lng], {
                radius: 8,
                fillColor: color,
                color: '#000',
                weight: 1,
                opacity: 1,
                fillOpacity: 0.8
            }).addTo(window.mapaBodegas);

            marker.bindPopup(`
        <div style="text-align: center;">
          <h5>${icono} ${punto.nombre}</h5>
          <p><strong>${punto.descripcion}</strong></p>
        </div>
      `);

            window.marcadoresMapa.push(marker);
            bounds.extend([punto.lat, punto.lng]);
        });

        // Agregar bodegas del cliente
        data.bodegas.forEach(bodega => {
            const marker = L.circleMarker([bodega.lat, bodega.lng], {
                radius: 10,
                fillColor: 'blue',
                color: '#000',
                weight: 2,
                opacity: 1,
                fillOpacity: 0.8
            }).addTo(window.mapaBodegas);

            marker.bindPopup(`
        <div style="text-align: center;">
          <h5>🏭 ${bodega.nombre}</h5>
          <p><strong>Dirección:</strong> ${bodega.direccion}</p>
          ${bodega.comuna ? `<p><strong>Comuna:</strong> ${bodega.comuna}</p>` : ''}
          ${bodega.region ? `<p><strong>Región:</strong> ${bodega.region}</p>` : ''}
        </div>
      `);

            window.marcadoresMapa.push(marker);
            bounds.extend([bodega.lat, bodega.lng]);
        });

        // Ajustar la vista del mapa para mostrar todos los puntos
        if (bounds.isValid()) {
            window.mapaBodegas.fitBounds(bounds, {padding: [20, 20]});
        }
    },

    actualizarMapa() {
        if (window.mapaBodegas) {
            this.cargarPuntosMapa();
        }
    }
};
